import { useEffect } from "react";
import { FullPageSpinner } from "components/Spinner";
import { FraudCheck } from "components/FraudCheck";
import { useSessionCtx, FLOW_STATE } from "utils";

/**
 * SessionID flow
 * @description
 * This flow is not meant to be viewed/interacted with by an end-user.
 * Instead, this is meant to be loaded in the user's browser when
 * an integrator is setting up a transaction with the user so Kount device
 * data can be collected (to be used in fraud check rules).
 * It is expected that when the integrator calls our invocing endpoints,
 * they will include this session ID so everything can be wrapped up together.
 * 
 * We should advise integrators to make the widget div a single pixel with
 * no visibility.
*/
const SessionID = ({ onReady, onComplete }) => {
  const { sessionId } = useSessionCtx();
  useEffect(onReady, [onReady]); // Trigger the onReady effect when the component mounts

  const handleFraudCheckOnComplete = () => {
    onComplete && onComplete({
        state: FLOW_STATE.COMPLETE,
        sessionId,
    });
  };

  return (
    <>
      <FraudCheck isAsync onComplete={handleFraudCheckOnComplete} />
      <FullPageSpinner />
    </>
  );
};

export default SessionID;
